//! вывод годов в фильтр от 2025 и далее по факту наступления след года
export const years = generateYears(2025, new Date().getFullYear());

function generateYears(fromYear: number, toYear: number) {
  const years = [];
  for (let year = fromYear; year <= toYear; year++) {
    // years.push({ ID: year - fromYear + 1, Title: String(year) });
    years.push({
      ID: year,
      Title: String(year),
    });
  }
  return years;
}

const toRomanNumeral = (num: number): string => {
  const romanNumerals = ['I', 'II', 'III', 'IV'];
  return romanNumerals[num - 1] || '';
};

const generateQuarters = (year: number) => {
  return [
    { ID: 1, Title: 'I', Value: 'Q1' },
    { ID: 2, Title: 'II', Value: 'Q2' },
    { ID: 3, Title: 'III', Value: 'Q3' },
    { ID: 4, Title: 'IV', Value: 'Q4' },
  ];
};

export const months = generateQuarters(new Date().getFullYear());

export const filterConfigFactoryGop = {
  yearGopReropt: {
    title: 'Год',
    hasSearch: false,
    options: years.map((item) => item.Title),
  },
  monthGopReropt: {
    title: 'Квартал',
    hasSearch: false,
    options: months.map((item) => item.Value),
  },
  groupGop: {
    title: 'Группа',
    hasSearch: true,
    searchPlaceholder: 'Поиск по группе',
    options: [],
  },
  factoryGop: {
    title: 'Завод',
    hasSearch: true,
    searchPlaceholder: 'Поиск по заводу',
    options: [],
  },
  formGopAction: {
    title: 'Форма GOP',
    hasSearch: true,
    searchPlaceholder: 'Поиск по форме GOP',
    options: [],
  },
  direction: {
    title: 'Направление',
    hasSearch: true,
    searchPlaceholder: 'Найти направление',
    options: [],
  },
  department: {
    title: 'Отдел/линия',
    hasSearch: true,
    searchPlaceholder: 'Найти отдел/линия',
    options: [],
  },
  blockDemand: {
    title: 'Блок требований',
    hasSearch: true,
    searchPlaceholder: 'Найти блок требований',
    options: [],
  },
  responsible: {
    title: 'Кто нажал "Завершить"',
    searchPlaceholder: '',
    hasSearch: false,
  },
  dataTable: {
    title: 'Дата завершения',
    hasSearch: false,
  },
};

const getCurrentDate = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  let currentQuarter;
  if (currentMonth <= 3) {
    currentQuarter = 1;
  } else if (currentMonth <= 6) {
    currentQuarter = 2;
  } else if (currentMonth <= 9) {
    currentQuarter = 3;
  } else {
    currentQuarter = 4;
  }

  const quarterName = `${toRomanNumeral(currentQuarter)}`;

  return {
    month: {
      id: currentQuarter,
      name: quarterName,
    },
    year: {
      id: currentYear,
      name: currentYear.toString(),
    },
  };
};

const currentDate = getCurrentDate();

export const initialFilterFactoryGop = {
  yearGopReropt: {
    selected: [currentDate.year.name],
    selectedIds: [currentDate.year.id],
  },
  monthGopReropt: {
    selected: [currentDate.month.name],
    selectedIds: [currentDate.month.id],
  },
  groupGop: { selected: ['BOP'], selectedIds: [1], search: '' },
  factoryGop: { selected: ['Владивосток'], selectedIds: [10], search: '' },
  formGopAction: { selected: ['Окружающая среда - BOP'], selectedIds: [146], search: '' },
  direction: { selected: [], selectedIds: [], search: '' },
  department: { selected: [], selectedIds: [], search: '' },
  blockDemand: { selected: [], selectedIds: [], search: '' },
  responsible: { selected: [], selectedIds: [], search: '' },
  dataTable: { startDate: '', endDate: '' },
};

export const filtersOpenFactoryGop = {
  yearGopReropt: false,
  monthGopReropt: false,
  groupGop: false,
  factoryGop: false,
  formGopAction: false,
  direction: false,
  department: false,
  blockDemand: false,
  responsible: false,
  dataTable: false,
};
